document.addEventListener('ShoptetDOMCartContentLoaded', function() { 
    
    $('.cart-widget-product').each(function(){
        $(this).find('.cart-widget-product-name').append('<span class="amountProduct">'+$(this).find('.cart-widget-product-amount input.amount').val()+' '+$(this).find('.cart-widget-product-unit').text()+'</span>')
    })

})

if($('.id--16, .id--17').length){
    $.get('/action/Cart/GetCartContent/?orderingProcessActive=1', function(data){   
        $('.cart-item[data-micro="cartItem"]').each(function(){
            get_id = $(this).attr('data-micro-sku')
            link = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image a').attr('href')
            image = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image img').attr('data-src').replace('related', 'detail')
            if(!$(this).find('.right').length){
                $(this).wrapInner('<div class="right"></div>')
                $(this).prepend('<div class="image"><a href="'+link+'"><img src="'+image+'" alt="'+$(this).find('a[data-testid="recapItemName"]').text()+'"></a></div>')
            }
        })
    })
    $('.cart-inner').prepend($('.cart-header'))
}

if($('.id--9').length){
    function mhProductInfoMove(){
        $('.cart-table tr').each(function(){
          var findcenazakus = $(this).find('.p-price.p-cell').html();
          var findptotal = $(this).find('.p-total');
          $(this).find('.p-name').append('<div class="avail">'+$(this).find('.p-availability').html()+'</div>')
          $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
        })
    };
    mhProductInfoMove()
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        mhProductInfoMove();
    });
}

if($('.id--17').length){
//    $('.cart-content>.co-contact-information .phone-form-group').after($('.form-group label[for="login"]').closest('.form-group'))
}

if($('.id--16').length){
    var customeEmail = getShoptetDataLayer('customer').email
		if(!BRNO_DELIVERY.includes(customeEmail)){
			$("#shipping-370").hide()
		}
		if(!PRAIS_DELIVERY.includes(customeEmail)){
			$("#shipping-379").hide()
		}
		if(getShoptetDataLayer('customer').groupId !== 2){
			$('#order-billing-methods div[data-id="billing-281"]').hide()
		}
		if(getShoptetDataLayer('customer').registered === false || getShoptetDataLayer('customer').groupId === 1){

            document.addEventListener('ShoptetBillingMethodUpdated', function() {
                $('#order-billing-methods .radio-wrapper[data-id="billing-3"]').find('input').prop('disabled', true)
                $('#order-billing-methods .radio-wrapper[data-id="billing-3"]').addClass('inactive-child').find('label').removeClass('active').addClass('inactive');
			    if(!$('.dobirkaMessage').length){
                    $('#order-billing-methods .radio-wrapper[data-id="billing-3"] .payment-info em').after('<div class="dobirkaMessage">'+dobirkaMessage+'</div>');
                }
            });
            $('#order-billing-methods .radio-wrapper[data-id="billing-3"]').find('input').prop('disabled', true)
            $('#order-billing-methods .radio-wrapper[data-id="billing-3"]').addClass('inactive-child').find('label').removeClass('active').addClass('inactive');
			if(!$('.dobirkaMessage').length){
                $('#order-billing-methods .radio-wrapper[data-id="billing-3"] .payment-info em').after('<div class="dobirkaMessage">'+dobirkaMessage+'</div>');
            }
		}
     
        
		if(getShoptetDataLayer('customer').registered){
			if(SHIPPING_PER_CUSTOMER.hasOwnProperty(customeEmail)){
				let customer_shipping_id = SHIPPING_PER_CUSTOMER[customeEmail]
				$('#shippingId-'+customer_shipping_id).prop('checked', true);
			    $('#shippingId-'+customer_shipping_id).click();
			}
			if(BILLING_PER_CUSTOMER.hasOwnProperty(customeEmail)){
				let customer_billing_id = BILLING_PER_CUSTOMER[customeEmail]
				$('#billingId-'+customer_billing_id).prop('checked', true);
			    $('#billingId-'+customer_billing_id).click();
			}
		}	
}